// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileList-cls1_fWU","cls2":"ProfileList-cls2_S59 ProfileList-cls1_fWU"};